import { ChatTarget } from "@components/chat-dock";

export type ChatNotificationKind = "sms" | "internal" | "job-chat" | "group" | "group-sms";

export interface ChatNotificationPayload {
  id: string;
  kind: ChatNotificationKind;
  companyId?: number | string | null;
  companyName?: string | null;
  title: string;
  body: string;
  target: ChatTarget;
  chatName?: string;
  focusMessageUid?: string | null;
  focusMessageText?: string | null;
}

type Listener = (payload: ChatNotificationPayload) => void;

const listeners = new Set<Listener>();

export const subscribeChatNotification = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitChatNotification = (payload: ChatNotificationPayload): void => {
  listeners.forEach((listener) => listener(payload));
};
